import type { I18NMessages } from '@atlaskit/intl-messages-provider/types';

export type AsyncLanguageLoader = () => Promise<{ default: I18NMessages }>;
export type AsyncLanguages = Record<string, AsyncLanguageLoader>;

const resolveLocaleKey = (locale: string, asyncLanguages: AsyncLanguages): string => {
	const language = locale.split(/[-_]/)[0] || '';
	const candidates = [locale, locale.replace('_', '-'), locale.replace('-', '_'), language];

	return candidates.find((candidate) => candidate in asyncLanguages) ?? language;
};

export const createFetchMessagesForLocale = (
	asyncLanguages: AsyncLanguages,
	defaultMessages: I18NMessages,
) => {
	return async (locale: string): Promise<I18NMessages> => {
		try {
			const languageLocale = resolveLocaleKey(locale, asyncLanguages);

			// Dynamic import of the locale file
			const localeMessages = await asyncLanguages[languageLocale]?.();

			return localeMessages?.default ?? defaultMessages;
		} catch (e) {
			// ignore
		}

		return defaultMessages;
	};
};
